import AddressField from '../../../_common/fields/AddressField';
import Checkbox from '../../../_common/fields/Checkbox';
import RadioButtonsField from '../../../_common/fields/RadioButtonsField';
import SelectField from '../../../_common/fields/SelectField';
import StringField from '../../../_common/fields/StringField';
import TextField from '../../../_common/fields/TextField';
import { InputType } from '../../../types/api';

export const fieldsMap = {
  [InputType.ADDRESS_PICKER]: AddressField,
  [InputType.DROP_DOWN]: SelectField,
  [InputType.PHONE_NUMBER]: StringField,
  [InputType.RADIO_BUTTONS]: RadioButtonsField,
  [InputType.SWITCH]: Checkbox,
  [InputType.TEXT_AREA]: TextField,
  [InputType.TEXT_FIELD]: StringField,
};
